import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function slugName(user) {
  return (user?.name || user?.user_id || "").toLowerCase().replace(/[^a-z0-9-]+/g, "-").replace(/^-+|-+$/g, "");
}

// Sidebar / header "Profile" → the signed-in user's PUBLIC profile. Session untouched.
export default function MyPublicProfileRedirect() {
  const { user, isAuthenticated, loading } = useAuth();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (loading) return;
    if (!isAuthenticated) { setTarget("/login?next=/app/profile/view"); return; }
    (async () => {
      try {
        const { data } = await api.get("/v1/profiles/me");
        const username = data?.username || slugName(user);
        setTarget(username ? `/songwriter/${username}` : "/app/profile");
      } catch { setTarget(`/songwriter/${slugName(user)}` || "/app/profile"); }
    })();
  }, [loading, isAuthenticated, user]);

  if (!target) return <div data-testid="profile-redirect" className="text-white/50 text-sm">Opening your public profile…</div>;
  return <Navigate to={target} replace />;
}
